import { Command, HttpMethod } from "~/extensions/api";
import { myPageStore } from "~/store/MyPageStore";
export class DeleteSaveListCommand extends Command {
    constructor(bulkTaikyoNo) {
        super(HttpMethod.Post, "taikyonotification/save/list/delete");
        this.bulkTaikyoNo = bulkTaikyoNo;
        this.userCd = myPageStore.personal.userCd;
    }
    bulkTaikyoNo = "";
    userCd = null;
}
